<div class="row">
    <div class="col-md-6 mx-auto pt-3">

        <h1>Nulstil adgangskode</h1>

        <div *ngFor="let alertString of alertStrings"
             [ngClass]="{'alert-danger': alertMode ==='danger', 'alert-success':  alertMode ==='success'}"
             class="alert "
             role="alert">
            {{ alertString }}
        </div>

        <a *ngIf="alertMode==='success'" class="btn  btn-sm btn-link"
           [routerLink]="['/login']"
        >
            <small class="text-muted">Log Ind</small>
        </a>


        <form (ngSubmit)="submit()" *ngIf="alertMode!=='success'">

            <div class="mb-3">
                <label class="form-label">
                    Adgangskode:
                </label>
                <input type="password" class="form-control" name="password" [(ngModel)]="loginData.password"
                       placeholder="Indtast adgangskode"/>

            </div>

            <div class="mb-3">

                <label class="form-label">
                    Gentag adgangskode:
                </label>
                <input [(ngModel)]="loginData.password_confirm" class="form-control" name="password_confirm"
                       placeholder="Gentag adgangskode"
                       type="password"/>

            </div>

            <button type="submit" class="btn btn-primary" [disabled]="logginIn"
                    [style]="{ 'pointer-events': logginIn ? 'none' : 'initial'}">
                <span *ngIf="!logginIn">Nulstil adgangskode</span>
                <span *ngIf="logginIn" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"><span class="sr-only">Loading...</span></span>
            </button>
        </form>
    </div>
</div>

